import fetch from 'auth/FetchInterceptor';
import { API_BASE_URL } from 'configs/AppConfig';

const BASE_URL = API_BASE_URL;

/**
 *
 * @param {FetchListParams} params
 * @returns {Promise<FetchLOIListResponse>}
 */
export function requestMainAgreementList(params) {
    /**
     * @NOTE This limit is hard code for now because we need to implement the sorting nad filterting only at front end.
     *  In future we may remove it when sorting and filterting is implemented on backend
     */
    return fetch.get(`${BASE_URL}/api/app/main-agreement/list?${params}`);
}


/**
 *
 * @param {LOI Data} mainAgreementData
 */
 export function requestCreateMainAgreement(mainAgreementData) {
    return fetch.post(`${BASE_URL}/api/app/main-agreement`, {
        ...mainAgreementData
    });
}

/**
 *
 * @param {LOI Data} mainAgreementData
 */
export function requestUpdateMainAgreement(mainAgreementData) {
    console.log(mainAgreementData);
    const data = { ...mainAgreementData };
    delete data['_id'];
    return fetch.put(`${BASE_URL}/api/app/main-agreement/${mainAgreementData._id}`, 
        data
    );
}

